import styled from 'styled-components';

import type { ExtendedTheme } from '@theme/theme';
import { LIGHT_THEME_KEY } from '@constants/theme';
import { customScrollStyle } from '@theme/GlobalStyle';

export const StyledCodeSnippet = styled.section`
  font-size: 14px;
  margin: 20px 0;
  position: relative;
  background: ${({ theme }: { theme: ExtendedTheme }) =>
    theme.palette.mode === LIGHT_THEME_KEY
      ? theme.palette.components.codeBgLight
      : theme.palette.components.codeBgDark};
  z-index: 0;

  &:before {
    content: '';
    position: absolute;
    width: 86px;
    top: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(
      90deg,
      rgba(242, 242, 242, 0) 0%,
      ${({ theme }: { theme: ExtendedTheme }) =>
          theme.palette.mode === LIGHT_THEME_KEY
            ? theme.palette.components.codeBgLight
            : theme.palette.components.codeBgDark}
        46px
    );
  }

  .code-wrap {
    position: relative;
    z-index: -1;
  }

  & > pre {
    font-family: 'Recursive', sans-serif;
    border-radius: ${({ theme }: { theme: ExtendedTheme }) => theme.shape.borderRadius}px;
    position: relative;
    padding: 30px;
    max-height: 560px;
    overflow: auto;
    letter-spacing: 0.02em;

    ${customScrollStyle}
    .token-line {
      .token {
        &:last-child {
          margin-right: 90px;
        }
      }
    }
  }

  button {
    position: absolute;
    top: 10px;
    right: 16px;
  }
`;
